import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, createHashRouter, RouterProvider } from 'react-router';
import { ROUTER_MODE } from '@shared/config.ts';
import '@shared/styles/shared.css';
import './public.css';
import { publicRoutes } from './routes.tsx';

const router = ROUTER_MODE === 'hash' ? createHashRouter(publicRoutes) : createBrowserRouter(publicRoutes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
